var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"workflow__nodes workflow__container"},[(_vm.resizeObserver)?_vm._l((_vm.getNodes),function(node){return _c('WorkflowNodeWrapper',{key:node.id,attrs:{"id":node.id,"resize-observer":_vm.resizeObserver}})}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }